/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-09-06 13:06:29
 * @LastEditors: changfeng
 * @LastEditTime: 2024-09-06 14:01:28
 */
import React, { Children, ReactNode, useState } from "react";
import { Button, Modal } from "antd";
import styles from "./index.less";
import contactUsQrCode from "@/assets/images/contact-us-qr-code-huanyu.webp";
import { useTranslation } from "react-i18next";
import ModalBg from "@/assets/icons/subscription/bg.svg";

export default function ProUpgradeButton(props: { className: string; children: ReactNode; buttonType: string }) {
	const { t } = useTranslation();
	const { className, buttonType, children } = props;
	const [isModalOpen, setIsModalOpen] = useState(false);

	const handleContact = () => {
		setIsModalOpen(true);
	};

	return (
		<>
			<Button type={buttonType} className={className} onClick={handleContact}>
				{/* 升级套餐 */}
				{children}
			</Button>
			<Modal
				width={498}
				footer={null}
				open={isModalOpen}
				className="modalBg"
				onCancel={() => {
					setIsModalOpen(false);
				}}
			>
				<div className="modalContent">
					<div className="modalText">如需购买企业版套餐，请扫描下面的二维码通过微信联系我们的客服团队</div>
					<img src={contactUsQrCode} alt={"QR Code"} width={208} height={208} />
				</div>
			</Modal>
		</>
	);
}
